<div
  class="ldk:tw-px-7 tw-flex tw-w-fit tw-items-center tw-justify-center tw-gap-2 tw-rounded-[0.625rem] tw-bg-gray-750 tw-px-5 tw-py-4 tw-shadow-[inset_0px_0px_20px_rgba(0,0,0,0.7)] dk:tw-px-[1.375rem]"
>
  @for (i of items(); track i) {
    @if (i < count()) {
      <puck_fill-icon [backgroundImage]="fillBackgroundImage()" />
    } @else {
      <puck_line-icon [backgroundImage]="lineBackgroundImage()" />
    }
  }
</div>
